export class NotificationMessage {
	message: string = null;
	type: string = null;
	timeout: number = 7000;
	scrollToTop: boolean = false;
	show: boolean = false;
}